export default "<div class=\"header\">\n    <img class=\"logo\" src=\"../../assets/images/logo.png\" alt=\"Pabst\">\n</div>\n"